import { useLoadScript } from '@react-google-maps/api'
import React, { PropsWithChildren, createContext, useContext } from 'react'

import config from 'constants/config'

type Libraries = Parameters<typeof useLoadScript>[0]['libraries']
export const GOOGLE_PLACE_LIBRARY_OPTIONS: Libraries = ['places', 'geometry', 'marker']

interface GoogleMapsContextProps {
  isLoaded: boolean;
}

const GoogleMapsContext = createContext<GoogleMapsContextProps>({
  isLoaded: false,
})

export const useGoogleMapsContext = () => {
  return useContext(GoogleMapsContext)
}

interface EnsureGoogleMapsLoadedProps {
  loadingElement?: React.ReactNode;
  children: React.ReactNode;
}
export function EnsureGoogleMapsLoaded({ loadingElement = null, children }: EnsureGoogleMapsLoadedProps) {
  const { isLoaded } = useGoogleMapsContext()
  return <>{isLoaded ? children : loadingElement}</>
}

export function GoogleMapsProvider(props: PropsWithChildren) {
  const { isLoaded } = useLoadScript({
    id: 'google-map-script',
    libraries: GOOGLE_PLACE_LIBRARY_OPTIONS,
    googleMapsApiKey: config.GOOGLE_MAPS_API_KEY,
  })

  const value = {
    isLoaded,
  }
  return (
    <GoogleMapsContext.Provider value={value}>
      {props.children}
    </GoogleMapsContext.Provider>
  )
}
